<div class="stepper-container">
  <button
    mat-icon-button
    class="stepper-arrow left-arrow"
    (click)="scrollLeft()"
    [disabled]="!canScrollLeft()"
    aria-label="Scroll Left"
  >
    <mat-icon class="arrow-icon material-icons-outlined">chevron_left</mat-icon>
  </button>

  <div class="steps-container" (scroll)="onScroll()">
    <div class="steps-list">
      @for (step of steps; track step.id) {
        <button
          type="button"
          class="step-item"
          [class.active]="isActive(step)"
          [class.completed]="isCompleted(step)"
          [class.disabled]="step.disabled"
          [class.clickable]="isClickable(step)"
          (click)="onStepClick(step)"
          [attr.aria-current]="isActive(step) ? 'step' : null"
        >
          <div class="step-content">
            <mat-icon class="step-icon material-icons-outlined">
              {{ getStepIcon(step) }}
            </mat-icon>
            <span class="step-label">
              {{ step.label }}
            </span>
          </div>
        </button>
      }
    </div>
  </div>

  <button
    mat-icon-button
    class="stepper-arrow right-arrow"
    (click)="scrollRight()"
    [disabled]="!canScrollRight()"
    aria-label="Scroll Right"
  >
    <mat-icon class="arrow-icon material-icons-outlined">
      chevron_right
    </mat-icon>
  </button>
</div>
